import React from "react";
import Back from "../common/back/Back";
import "./policies.css";

const TermsOfService = () => {
  return (
    <div className="policy-page">
      <Back title="Terms of Service" />
      <div className="container policy-container">
        <div className="policy-content">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using the Welsh Education website and services, you accept and agree to be bound by the terms and provision of this agreement.</p>

          <h2>2. Use of Services</h2>
          <p>Our services, including counseling, test preparation, and visa assistance, are provided to help you achieve your educational goals. You agree to use these services only for lawful purposes.</p>

          <h2>3. Intellectual Property</h2>
          <p>All content included on this site, such as text, graphics, logos, and images, is the property of Welsh Education or its content suppliers and protected by international copyright laws.</p>

          <h2>4. Limitation of Liability</h2>
          <p>Welsh Education shall not be liable for any indirect, incidental, special, consequential or punitive damages resulting from your use of or inability to use the service.</p>

          <h2>5. User Accounts</h2>
          <p>If you create an account on our platform, you are responsible for maintaining the security of your account and you are fully responsible for all activities that occur under the account.</p>

          <h2>6. Changes to Terms</h2>
          <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
